var plugin = require('tailwindcss/plugin');

var _ = require('lodash');

module.exports = plugin(function (_ref) {
  var theme = _ref.theme,
      variants = _ref.variants,
      e = _ref.e,
      addUtilities = _ref.addUtilities;

  var filterUtilities = _.fromPairs(_.map(theme('filter'), function (value, modifier) {
    return [".".concat(e("filter-".concat(modifier))), {
      filter: value
    }];
  }));

  var backdropFilterUtilities = _.fromPairs(_.map(theme('backdropFilter'), function (value, modifier) {
    return [".".concat(e("backdrop-".concat(modifier))), {
      backdropFilter: value
    }];
  }));

  addUtilities(filterUtilities, variants('filter'));
  addUtilities(backdropFilterUtilities, variants('backdropFilter'));
}, {
  theme: {
    filter: {},
    backdropFilter: {}
  },
  variants: {
    filter: ['responsive'],
    backdropFilter: ['responsive']
  }
});